import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
const EmptyState = React.forwardRef(function EmptyState2({ title, body, action, icon, className, ...rest }, ref) {
  return /* @__PURE__ */ jsxs("div", { ref, className: cx("ev-empty", className), ...rest, children: [
    icon != null && icon !== false ? /* @__PURE__ */ jsx("span", { className: "ev-empty__icon", "aria-hidden": "true", children: icon }) : null,
    /* @__PURE__ */ jsx("span", { className: "ev-empty__title", children: title }),
    body != null && body !== false ? /* @__PURE__ */ jsx("span", { className: "ev-empty__body", children: body }) : null,
    action != null && action !== false ? /* @__PURE__ */ jsx("div", { className: "ev-empty__action", children: action }) : null
  ] });
});
export {
  EmptyState
};
//# sourceMappingURL=EmptyState.js.map
